function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

jQuery(document).ready(function($) {

    // Apply style to a if touch device
    if (isTouchDevice()) {
        $('a, button, input, .faq_question').addClass('touch-device');
        $('a, button, input, .faq_question').removeClass('click-device');
    } else {
        $('a, button, input, .faq_question').addClass('click-device');
        $('a, button, input, .faq_question').removeClass('touch-device');
    }

});
//# sourceMappingURL=device-recognition.js.map
